import React, { useState } from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import { Plus, Trash } from "react-bootstrap-icons";

import { dmyString } from "../../helper";
import RepairForm from "./RepairForm";
import { Button, Modal } from "react-bootstrap";
import { REPAIRS_URL } from "../api_urls";
import configuredAxios from "../../configured-axios";
import { toast } from "react-toastify";

function RepairList(props) {
  const [showForm, setShowForm] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [repairToDelete, setRepairToDelete] = useState(undefined)

  const repairTableRows = []
  for (const repair of props.repairs) {
    repairTableRows.push(
      <tr key={repair.id}>
        <td>{dmyString(repair.date)}</td>
        <td>{repair.description}</td>
        <td width={65}><Button variant='outline-danger' onClick={() => {
          setShowDeleteModal(true)
          setRepairToDelete(repair.id)
        }}><Trash /></Button></td>
      </tr>
    )
  }

  return (
    <>
      <Container>
        <h4>
          Repairs&nbsp;
          <Plus onClick={() => setShowForm(!showForm)} />
        </h4>
        {showForm && (
          <RepairForm
            containerBoxId={props.containerBoxId}
            onRepairFormSubmit={props.onRepairFormSubmit}
            handleShowForm={setShowForm}
          />
        )}
        <Table bordered hover>
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th width={65} className="text-center"><Trash /></th>
            </tr>
          </thead>
          <tbody>
            {
              repairTableRows.length > 0 ?
              repairTableRows :
              <tr>
                <td colSpan="3">No Repairs Found</td>
              </tr>
            }
          </tbody>
        </Table>
      </Container>
      <Modal show={showDeleteModal}>
        <Modal.Body>
          Are you sure you want to delete this repair?
          <br />
          <br />
          This cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant='danger' onClick={() => {
            configuredAxios.delete(REPAIRS_URL + "/" + repairToDelete).then(() => {
              props.onRepairFormSubmit()
              setShowDeleteModal(false)
              toast.success('Successfully removed repair')
            }).catch(() => {
              toast.error('An error occurred while removing repair')
            })
          }}>Delete</Button>
          <Button variant='dark' onClick={() => {
            setRepairToDelete(undefined)
            setShowDeleteModal(false)
          }}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RepairList;
